import { FloorGrid } from "@volca/ui/components/ui/floor-grid";
import { cn } from "@volca/ui/lib/utils";

export const MachineBackdrop = ({
  floor,
  className,
}: {
  floor: [number, number];
  className?: string;
}) => (
  <FloorGrid
    floor={floor}
    data-machine-backdrop
    className={cn("-z-10 opacity-35 forced-colors:hidden", className)}
  />
);
